<template>
	<div class="logo h-auto">
		<img
			class="w-full block h-auto"
			:style="{
				'maxWidth': maxWidth
			}"
			:src="src"
			:alt="title"
			:title="title"
		/>
	</div>
</template>

<script>
export default {
	name: 'UiLogo',
	props: {
		src: {
			type: String,
			required: true
		},
		maxWidth: {
			type: String,
			default: 'auto'
		},
		title: {
			type: String,
			default: ''
		}
	}
}
</script>